import script from "./SubscriptionsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionsTable.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionsTable.vue?vue&type=style&index=0&id=3fc659f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc659f0"]])

export default __exports__